import React from 'react';
import { StyleSheet } from 'react-native';
import { Container } from '@mui/system';
import { Box, Typography } from '@mui/material';
import FAQItem from '../../components/Collapsible/Collapsible';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { faqs } from './data';
import { strings } from '../../constants';

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});

const FAQ = () => {
    const { themeStyle } = useThemeContext();

    return (
        <Container disableGutters style={styles.container} maxWidth={false}>
            <Box sx={{ width: '100%' }}>
                <Typography
                    sx={{
                        mb: 2,
                        fontSize: {
                            sm: 24,
                            xs: 16,
                            lg: 24,
                        },
                    }}
                    style={{
                        fontFamily: FONT_ENUM.REGULAR_HEADER,
                        color: theme[themeStyle].lightWhite,
                    }}>
                    {strings.faq}
                </Typography>
                {faqs.map((faq, index) => (
                    <FAQItem key={index} question={faq.question} answer={faq.answer} />
                ))}
            </Box>
        </Container>
    );
};

export { FAQ };
